import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, forwardRef } from "@angular/core";
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { Storage } from "@ionic/storage-angular";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { format, parseISO } from "date-fns";

/*
  _/﹋\_
  (҂`_´) - Exemplo de uso do componente ProverHorasComponent:
  <;︻╦╤─ ҉ - - - - - - - - - - - - -

  <app-prover-horas
    [labelName]="'Nome da label'"                                            \\ Texto que aparecerá como label do campo
    [id]="'data'"                                                            // ID único do componente/modal
    [(timeValue)]="pessoa.horaInicio"                                        \\ Valor da hora
    formControlName="seuFormControl"                                         // Nome do FormControl para reactive forms
    [required]="true"                                                        \\ Indica se o campo é obrigatório
    [isLabel]="true"                                                         // Esconde a label do componente 
    [isColor]="{ 'color': '#ffff' }"                                       \\ Color para horario selecionado
    [disabled]="validations_form.get('dataHoraFim_data')?.disabled ?? false" // Para disabilitar a edição da data
  ></app-prover-horas>
*/

@Component({
  selector: "app-prover-horas",
  templateUrl: "./prover-horas.component.html",
  styleUrls: ["./prover-horas.component.scss"],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, ReactiveFormsModule, FormsModule, DateFormatPipe],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProverHorasComponent),
      multi: true,
    },
  ],
})
export class ProverHorasComponent {
  @Input() public labelName: string = "Hora";
  @Input() id: any;
  @Input() public timeValue: string;
  @Input() public required = false;
  @Output() public timeValueChange = new EventEmitter<string>();
  @Input() public isLabel = false;
  @Input() public isColor: any;
  @Input() disabled: boolean = false;

  idioma: string = "pt-BR";

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    const horaAtual = format(new Date(), "HH:mm");

    setTimeout(() => {
      this.timeValue = value || horaAtual;
      this.timeValueChange.emit(this.timeValue);
      this.onChange(this.timeValue);
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  constructor(private storage: Storage) {
    this.getIdioma();
  }

  changeTime(event: any) {
    const rawValue = event.detail.value;
    let timeValue: string;

    if (rawValue?.includes("T")) {
      timeValue = format(parseISO(rawValue), "HH:mm");
    } else {
      timeValue = rawValue?.substring(0, 5);
    }

    this.timeValue = timeValue;
    this.timeValueChange.emit(timeValue);
    this.onChange(timeValue);
    this.onTouched();
  }

  async getIdioma(): Promise<string | null> {
    const value = await this.storage.get("idioma");
    this.idioma = value || "pt-BR";
    return value;
  }
}
